import './subnav.scss';

function SubMenuItem({ menuitem, onClick, selected, alwaysShow, customWidth }) {
  return (
    <>
      <div
        onClick={() => onClick(menuitem)}
        className={`SubNavMenuItem ${menuitem.title === selected && 'active'} ${customWidth ? 'customWidth' : ''} ${alwaysShow ? 'alwaysShow' : ''}`}
        style={alwaysShow ? { justifyContent: 'center', alignItems: 'center' } : {}}
      >
        <div className="SubNavItemIcon">{menuitem?.icon}</div>
        <div className="SubNavItemTitle">{menuitem?.title}</div>
      </div>
    </>
  );
}

export function CustomSubNav({ menuitems, onChange, selected, alwaysShow = false, customWidth = false }) {
  return (
    <div className={`SubNav ${alwaysShow ? 'alwaysShow' : ''} ${customWidth ? 'customWidth' : ''}`} style={alwaysShow ? { display: 'flex', width: '100%' } : {}}>
      {menuitems.map((menuitem) => (
        <SubMenuItem
          key={`${menuitem.icon}-${menuitem.title}`}
          onClick={(selectedItem) => onChange(selectedItem)}
          menuitem={menuitem}
          selected={selected}
          alwaysShow={alwaysShow}
          customWidth={customWidth}
        />
      ))}
    </div>
  );
}
